import $ from "jquery";
import imagesLoaded from "imagesloaded";
import tinymce from "tinymce";

// Register $().imagesLoaded() on our jQuery. Imports are hoisted, so
// window.jQuery isn't set yet when imagesloaded checks for it on load.
imagesLoaded.makeJQueryPlugin($);
window.jQuery = $;
window.$ = $;
import "masonry-layout";
import "jquery.scrollto";
// Import your own JS files
import "../domain/static/site/js/djg.base.js";
import "../portfolio/static/site/js/portfolio.js";
// Add more imports as needed

// Initialize TinyMCE for inlineedit fields if superuser
if (typeof window !== "undefined" && window.is_superuser) {
  function initTinyMCE() {
    document.querySelectorAll('.inlineedit-edit textarea:not([readonly]):not([disabled]), .inlineedit-edit [contenteditable="true"]:not([readonly]):not([disabled])').forEach(function(el) {
      if (!el.classList.contains('tinymce-applied')) {
        tinymce.init({
          target: el,
          menubar: false,
          plugins: 'link lists code',
          toolbar: 'undo redo | bold italic underline | bullist numlist | link | code',
          setup: function(editor) {
            editor.on('init', function() {
              el.classList.add('tinymce-applied');
            });
          }
        });
      }
    });
  }
  document.addEventListener("DOMContentLoaded", function() {
    initTinyMCE();
    document.body.addEventListener('DOMNodeInserted', function(e) {
      if (e.target && (e.target.classList && e.target.classList.contains('inlineedit-edit'))) {
        initTinyMCE();
      }
    });
  });
}
